/*
 * sidebar-options
 */
import type { AuthUser } from "@psychology/types"
import type { ReactNode } from "react"
import { SidebarOptionsItem } from "./sidebar-options-item"
import { SidebarOptionsItemMenu } from "./sidebar-options-item-menu"

interface SidebarOptionsProps {
	getSidebarMenuList: (user?: AuthUser | null, devMode?: boolean) => any[]
	bottomContent?: ReactNode
	user?: AuthUser | null
	devMode?: boolean
	children?: ReactNode
	className?: string
}

export function SidebarOptions({
	getSidebarMenuList,
	user,
	devMode,
}: SidebarOptionsProps) {
	const menuList = getSidebarMenuList(user, devMode)

	return menuList.map((content: any, index: number) => (
		<SidebarOptionsItem groupLabel={content.groupLabel} key={index}>
			{content.menus.map(
				({ href, label, icon: Icon, submenus }: any, index: number) => (
					<SidebarOptionsItemMenu
						to={href}
						label={label}
						submenus={submenus}
						Icon={<Icon className={"size-4"} />}
						key={index}
					/>
				),
			)}
		</SidebarOptionsItem>
	))
}
